import { createApp, h } from 'vue'
import AccessGate from './AccessGate.vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/uefa-theme.css'

createApp({ render: () => h(AccessGate, null, { default: () => h(App) }) }).use(store).use(router).mount('#app')
